/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class FacebookOutput extends React.Component {
    render() {
        let serviceMessage = null,
            constants = this.props.app.config.constants,
            type = 'Page';

        if (this.props.subtype === constants.FB_SUBTYPE_GROUP) {
            serviceMessage = (
                <span>Connecting a Facebook Group? Additional step required — <a href="https://support.dlvrit.com/hc/en-us/articles/360007690813" target="_blank">Read More</a></span>
            );
            type = 'Group';
        }

        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy={`Select a Facebook ${type}`}
                    serviceMessage={serviceMessage}/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Facebook Pages to dlvr.it</p>
                    )}
                    ineligibleMessage={(
                        <div>
                            <p className="chooser-notice short-bottom">These socials are not eligible for posting.</p>
                            <p className="chooser-notice small">Facebook doesn't allow <a href="https://support.dlvrit.com/hc/en-us/articles/360007291174" target="_blank">3rd parties to post to profiles.</a> Facebook pages require <a href="https://www.facebook.com/help/289207354498410" target="_blank">specific permissions.</a></p>
                        </div>
                    )}
                    unavailableMessage={"Pages you've already connected"}
                    typeLabel={type}/>
            </div>
        );
    }
}

FacebookOutput.displayName = "FacebookOutput";

export default FacebookOutput;
